module.exports = __webpack_public_path__ + "img/security-record.d0289dc0.png";